<template>
  <div class="mobile mwr2025-stats bg" id="mwr2025-stats-page" :class="locale">
    <ActLang v-show="!state.saving"/>
    <UserInfo class="user-info" v-show="!state.saving"/>
    <Book class="book" id="book-page" :bookData="state.bookData" :saving="state.saving" />
    <!-- mwr2025-stats
    <button @click="goHome">go home</button>
    <button @click="goDragon">go dragon</button> -->
    <div class="router-links" v-show="!state.saving">
      <div class="router-link home" @click="goHome"></div>
      <div class="router-link dragon" @click="goDragon"></div>
    </div>
    <div class="btns" v-show="!state.saving">
      <div class="btn save-btn" @click="savePageImage">
        <span class="text">{{ $t('mwr.save') }}</span>
        <i class="icon icon-save"></i>
      </div>
      <div class="btn share-btn" @click="state.shareDialog.visible = true">
        <span class="text">{{ $t('mwr.share') }}</span>
        <i class="icon icon-share"></i>
      </div>
    </div>
    <ShareDialog v-model="state.shareDialog.visible" @shareSuccess="handleShareSuccess" />
    <ActTimeDialog></ActTimeDialog>
  </div>
</template>

<script setup>
/* eslint-disable */
import { reactive, onMounted, watch, computed, inject, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import UserInfo from '../components/UserInfo/index.vue'
import Book from './components/book/index.vue'
import ShareDialog from '../components/Dialog/ShareDialog/index.vue'
import html2canvas from 'html2canvas'
import MwrActApi from '@/config/mwrActApi'
import { useStore } from 'vuex'
import RotatePhone from '@/components/RotatePhone/index.vue'
import { isMobile } from '@/utils'
import ActLang from '../components/ActLang/index.vue'
import { useI18n } from 'vue-i18n'
import ActTimeDialog from '../components/Dialog/ActTimeDialog/index.vue'
const { locale } = useI18n()
const mwrData = inject('mwrData')
const mwrFn = inject('mwrFn')
const store = useStore()
const router = useRouter()
const getDefaultStatsData = () => {
  return {
    saving: false,
    totalGameTime: 0,
    totalKillCount: 0,
    alwaysPlayMode: 0,
    alwaysPlayModeTime: 0,
    maxRankScore: 0,
    maxSavageRankScore: 0,
    maxBrRankScore: 0,
    maxWeaponId: 0,
    maxLongWinningCount: 0,
    maxLongLoginDays: 0,
    topFriendId: '',
    totalWeaponCount: 0,
    totalAvtCount: 0,
    userTitle: {
        isForty: 0,
        isTwenty: 0,
        isGame100: 0,
        modeID: 0,
        weaponType: '',
        is10WValue: 0,
        is15WValue: 0,
        is20WValue: 0
    }
  }
}
const state = reactive({
  cpUserInfo: computed(() => store.state.cpUserInfo),
  statsData: getDefaultStatsData(),
  shareDialog: {
    visible: false
  },
  bookData: [
    {
      data: [
        {
          title: 'title1',
          content: 'content1'
        }
      ],
      page: 1
    },
    {
      data: [
        {
          title: 'title2',
          content: 'content2'
        }
      ],
      page: 2
    },
    {
      data: [
        {
          title: 'title3',
          content: 'content3'
        }
      ],
      page: 3
    },
    {
      data: [
      {
          title: 'title3',
          content: 'content3'
        }
      ],
      page: 4
    },
    {
      data: [
      {
          title: 'title3',
          content: 'content3'
        }
      ],
      page: 5
    },
    {
      data: [
      {
          title: 'title3',
          content: 'content3'
        }
      ],
      page: 6
    },
  ]
})
const handleShareSuccess = async () => {
  if (mwrData.taskDetail.shareMwr !== 0) {
    return
  }
  await MwrActApi.recordUserAction({
    actionType: 'shareMwr',
  })
  mwrFn.updateShareTaskStatus()
}
const goHome = () => {
  router.push({ name: 'MWR2025Home' })
}
const goDragon = () => {
  router.push({ name: 'MWR2025Dragon' })
}

const savePageImage = async () => {
  try {
    state.saving = true
    nextTick(async () => {
      const pageImage = await html2canvas(document.querySelector('#mwr2025-stats-page'), {
        useCORS: true,        // 允许跨域图片（需要图片服务器支持CORS）
        allowTaint: false,    // 不允许污染画布（如果设为true，会导致toDataURL失败）
        logging: false,       // 关闭日志
        scale: 2,             // 提高清晰度（可选）
        // backgroundColor: '#333333' // 设置背景色（可选）
      })
      const link = document.createElement('a')
      link.href = pageImage.toDataURL('image/png')
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hour = date.getHours()
      const minute = date.getMinutes()
      const second = date.getSeconds()
      const formattedDate = `${year}${month}${day}${hour}${minute}${second}`
      link.download = `mwr2025-${formattedDate}.png`
      link.click()
    })
    setTimeout(() => {
      state.saving = false
    }, 2000)
  } catch (error) {
    console.error(error)
    state.saving = false
  }
}

const getStatsData = async () => {
  if (!state.cpUserInfo.cpUserId) {
    console.log('cpUserId is empty')
    state.statsData = getDefaultStatsData()
    return
  }
  // console.log('MwrActApi.getStatsData before')
  // const res = await MwrActApi.getStatsData()
  // console.log(res, 'res getStatsData22')
  // alert(JSON.stringify(res, null, 2))
  // state.bookData[0].data[0].title = res // todo 先临时测试，后面再优化
}

const init = () => {
  getStatsData()
}

const reset = () => {
  init()
}

init()

watch(() => state.cpUserInfo, () => {
  reset()
}, { deep: true })

</script>

<style scoped lang="less" src="./mobile_style.less"></style>
